import React from 'react';
import CustomerContactInfoComp from './CustomerContactInfoComp';

const CustomerContactInfoEmailVerify = props =>
  (
<CustomerContactInfoComp
  {...props}
  description="Re-enter your email address"
  errorMessages={{
    'field_is_required': 'The email field is required',
    'field_is_invalid': 'Your email is invalid',
    'field_does_not_match': 'Email addresses do not match',
  }}
  label="Verify email"
  name="emailVerify"
  onPaste={e => e.preventDefault()}
  type="email"
/>
  );

export default CustomerContactInfoEmailVerify;
